import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Chip from '@mui/material/Chip';
import { useTheme } from '@mui/material/styles';
import DescriptionRoundedIcon from '@mui/icons-material/DescriptionRounded';
import NewspaperRoundedIcon from '@mui/icons-material/NewspaperRounded';

const roles = ['Java Developer', 'Tech Lead', 'Team Lead', 'Speaker', 'Lecturer'];

const HeroSection: React.FC = () => {
    const theme = useTheme();
    const dark = theme.palette.mode === 'dark';

    return (
        <Box sx={{ pt: { xs: 8, md: 14 }, pb: { xs: 8, md: 12 }, position: 'relative', overflow: 'hidden' }}>
            <Box sx={{ position: 'absolute', top: -100, right: -100, width: dark ? 600 : 1000, height: dark ? 600 : 1000, borderRadius: '50%', background: dark ? 'radial-gradient(circle, rgba(96,165,250,0.08) 0%, transparent 70%)' : 'radial-gradient(circle, rgba(37,99,235,0.13) 0%, transparent 70%)', pointerEvents: 'none' }} />
            <Box sx={{ position: 'absolute', bottom: -200, left: -200, width: dark ? 600 : 1000, height: dark ? 600 : 1000, borderRadius: '50%', background: dark ? 'radial-gradient(circle, rgba(124,58,237,0.06) 0%, transparent 70%)' : 'radial-gradient(circle, rgba(124,58,237,0.09) 0%, transparent 70%)', pointerEvents: 'none' }} />

            <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 1 }}>
                <Box sx={{ maxWidth: 720 }}>
                    <Typography variant="body1" sx={{ color: 'primary.main', fontWeight: 600, mb: 2, fontSize: '1.1rem' }}>
                        👋 Hello, I'm
                    </Typography>

                    <Typography variant="h1" sx={{
                        fontSize: { xs: '2.5rem', sm: '3.5rem', md: '4rem' }, mb: 2, lineHeight: 1.1,
                        background: dark ? 'linear-gradient(135deg, #F1F5F9 0%, #94A3B8 100%)' : 'linear-gradient(135deg, #0F172A 0%, #334155 100%)',
                        backgroundClip: 'text', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent',
                    }}>
                        Aleksandr Pashchenko
                    </Typography>

                    <Typography variant="h4" sx={{ color: 'text.secondary', fontWeight: 400, mb: 3, fontSize: { xs: '1.2rem', md: '1.6rem' }, lineHeight: 1.5 }}>
                        Senior Java Developer & Tech Lead building{' '}
                        <Box component="span" sx={{ color: 'primary.main', fontWeight: 600 }}>high-load distributed systems</Box>,
                        teaching at universities, and speaking at tech conferences.
                    </Typography>

                    <Stack direction="row" flexWrap="wrap" gap={1} sx={{ mb: 5 }}>
                        {roles.map(r => (
                            <Chip key={r} label={r} variant="outlined" sx={{ borderColor: theme.palette.divider, fontWeight: 500, fontSize: '0.85rem', height: 36 }} />
                        ))}
                    </Stack>

                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                        <Button component={RouterLink} to="/cv" variant="contained" size="large" startIcon={<DescriptionRoundedIcon />}
                                sx={{ px: 4, py: 1.5, background: 'linear-gradient(135deg, #2563EB 0%, #7C3AED 100%)', boxShadow: '0 4px 20px rgba(37,99,235,0.3)', '&:hover': { background: 'linear-gradient(135deg, #1D4ED8 0%, #6D28D9 100%)' } }}>
                            View CV
                        </Button>
                        <Button component={RouterLink} to="/news" variant="outlined" size="large" startIcon={<NewspaperRoundedIcon />}
                                sx={{ px: 4, py: 1.5, borderWidth: 2, '&:hover': { borderWidth: 2 } }}>
                            Read Blog
                        </Button>
                    </Stack>
                </Box>
            </Container>
        </Box>
    );
};

export default HeroSection;
